import icon from '@material-ui/icons/Person'

import list from './list'

export default { list, icon, options: { label: 'Player Images' } }
